
import Capability from '../components/Capabilities/Capability'
import BuildPowerful from '../components/Capabilities/BuildPowerful'
import OurCapable from '../components/Capabilities/OurCapable'
import { SEO } from '../utils/SEO'

export default function Capabilities() {
    SEO({
        title: 'Technology Capabilities | SAN Technovation',

        description:
            'Explore SAN Technovation’s technology capabilities in software development, embedded systems, IoT solutions, automation, web and mobile application development, UI/UX design, and digital engineering services.',

        keywords:
            'SAN Technovation, Technology Capabilities, IT Solutions Company, Software Development, Custom Software Development, Embedded Systems, IoT Solutions, Industrial IoT, Automation Systems, Web Development, Mobile App Development, UI UX Design, Digital Engineering, Enterprise Software, Business Automation, Digital Transformation, MERN Stack Development',

        author: 'SAN Technovation',

        ogTitle:
            'Technology Capabilities | SAN Technovation',

        ogDescription:
            'Discover SAN Technovation’s expertise in software development, embedded systems, IoT solutions, automation technologies, web and mobile applications, UI/UX design, and digital transformation services.',

        ogType: 'website',

        ogSiteName: 'SAN Technovation',
        canonical: 'https://www.santechnovation.com/capable'
    })
    return (
        <main>
            <Capability />
            <OurCapable />
            <BuildPowerful />

        </main>
    )
}

